import { PlanejamentoTabelaView } from "./view-planejamento-tabela";
import type { PlanejamentoTabelaProps } from "./types-planejamento-tabela";

export function PlanejamentoTabela(props: PlanejamentoTabelaProps) {
  return <PlanejamentoTabelaView {...props} />;
}

export type * from "./types-planejamento-tabela";
